<template>
    <div class="flex transition items-center">

          <div v-if="!popoutHidden" class="absolute w-full bg-white top-0 block ml-32">
            <a v-on:click="popoutHidden = true" class="nav-icon align-middle cursor-pointer is-active"> 
                <i aria-hidden="true" class="material-icons pr-0">account_circle</i>
                  <span>Account</span>
            </a>
            <transition name="fade">
              <div class="">
                <div class="w-1/12"></div>
                <slot></slot>
              </div>
            </transition>
          </div>
        
      </div>
</template>

<script>
  export default {

        props: {
            value: '',
            datagroup:'',
            route:'',
            route_name:'',
            classes:''
        },

        data() {
          return {
            popoutHidden: true,
            success: false,
            loaded: true,
            value: '',
          }
        },

      }
</script>
